import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerCreateSlice = createApi({
    reducerPath: "customerCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        customerCreate: builder.mutation({
            query: (data) => ({ url: "/order-management/api/v1/customer/create", method: "POST", body: data }),
        }),
    }),
});

export const { useCustomerCreateMutation } = customerCreateSlice;
